import React, { useState, useEffect } from 'react';
import AdminHeader from '../../components/Header/AdminHeader';
import AdminSideBar from '../../components/SideBar/AdminSideBar';
import AdminFooter from '../../components/Footer/AdminFooter';
import activateorgStyle from './ActivatedSchoolsOrgPage.module.css';
import { Link, useNavigate } from 'react-router-dom';
import BackBar from '../../components/BackBar/BackBar'
import DataTable from 'react-data-table-component';
import axios from "axios";
import Swal from "sweetalert2";

export default function ActivatedSchoolsOrgPage() {
  const [schools, setSchools] = useState([]);
  const [filteredSchools, setFilteredSchools] = useState([]); // Schools filtered by selected ones
  const [selectedSchools, setSelectedSchools] = useState([]);
  const [selectedFromYear, setSelectedFromYear] = useState(""); // Store the selected from year
  const [selectedToYear, setSelectedToYear] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [sendingId, setSendingId] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    // Fetch the data from your PHP API
    const fetchSchools = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/get_cordinator_school_data.php?school_flag=Active`);
        const data = await response.json();
        if (data.success) {
          setSchools(data.users);
          setFilteredSchools(data.users);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSchools();
  }, []);

  const currentYear = new Date().getFullYear();
  const fromyears = [];
  for (let year = 2022; year <= currentYear; year++) {
    fromyears.push(year);
  }

  const toyears = [];
  for (let year = 2022; year <= currentYear; year++) {
    toyears.push(year);
  }

  // Handle the change in the multi-select dropdown
  const handleSchoolSelectChange11 = (event) => {
    const selectedOptions = Array.from(event.target.selectedOptions, option => option.value);
    setSelectedSchools(selectedOptions);
    if (selectedOptions.includes("All")) {
      // If "All" is selected, show all schools
      setFilteredSchools(schools);
    } else {
      // Otherwise, filter schools by the selected schools
      const filtered = schools.filter(school => {
        return selectedOptions[0]?.toLowerCase().includes(school.school_name?.toLowerCase().replace(/\s+/g, ' ').trim());
      });
      setFilteredSchools(filtered);
    }
  };

  const handleSchoolSelectChange = (event) => {
    const selectedOptions = Array.from(
      event.target.selectedOptions,
      option => option.value.trim().toLowerCase()
    );

    setSelectedSchools(selectedOptions);

    if (selectedOptions.includes("all")) {
      setFilteredSchools(schools);
      return;
    }

    const filtered = schools.filter(school => {
      const schoolName = school.school_name?.replace(/\s+/g, ' ').trim().toLowerCase();

      return selectedOptions.includes(schoolName);
    });

    setFilteredSchools(filtered);
  };

  const handleSendContract = async (cordinatorId) => {
    try {
      setSendingId(cordinatorId);

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}authormeetapi/send_contract.php`,
        { cordinator_id: cordinatorId },
        { headers: { 'Content-Type': 'application/json' } }
      );

      if (response.data.success) {
        Swal.fire({
          icon: 'success',
          title: 'Contract Sent',
          text: 'The contract has been sent successfully.',
          timer: 2000,
          showConfirmButton: false,
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: response.data.message || 'Failed to send contract.',
        });
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Something went wrong while sending the contract.',
      });
    } finally {
      setSendingId(null);
    }
  };


  // Effect to handle "To Year" reset or filtering based on "From Year"
  useEffect(() => {
    if (selectedFromYear && selectedToYear) {
      setFilteredSchools(filterSchools());
    }
  }, [selectedFromYear, selectedToYear]);
  // Handle "From Year" change
  const handleFromYearChange = (e) => {
    setSelectedFromYear(Number(e.target.value));
  };

  // Handle "To Year" change
  const handleToYearChange = (e) => {
    setSelectedToYear(Number(e.target.value));

    // setFilteredSchools(filterSchools());
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);

    const filtered = schools.filter((school) =>
      school.school_name.toLowerCase()?.includes(value.toLowerCase()) ||
      school.created_date?.includes(value) ||
      school.flag?.toString().includes(value)
    );

    setFilteredSchools(filtered);
  };

  const filterSchools = () => {
    if (!selectedFromYear || !selectedToYear) {
      return schools; // If either "From Year" or "To Year" is not selected, return all schools
    }
    return schools.filter((school) => {
      const schoolYear = new Date(school.cdate).getFullYear();
      return schoolYear >= selectedFromYear && schoolYear <= selectedToYear;
    });
  };

  if (isLoading) {
    return <div></div>; // Show loading state while fetching data
  }

  // DataTable columns configuration
  const columns = [
    {
      name: 'Date Submitted',
      selector: row => row.created_date,
      sortable: true,
      minWidth: '120px',
    },
    {
      name: 'Date Activated',
      selector: row => row.activated_date,
      sortable: true,
      minWidth: '120px',
    },
    {
      name: 'School/Organization Name',
      selector: row => row.school_name,
      sortable: true,
      minWidth: '200px',
      cell: row => (
        <Link to={`/ActivatedSchoolsOrgDetailsPage/${row.cordinator_id}`} className="text-primary">
          {row.school_name}
        </Link>
      ),
    },
    /* {
       name: 'Send Contract',
       minWidth: '140px',
       cell: row => (
         const isSending = sendingId === row.cordinator_id;
         const isSigned = row.contract_signed;
         <button className={`${activateorgStyle.contractButton} btn btn-primary`} disabled={sendingId === row.cordinator_id}
         onClick={() => handleSendContract(row.cordinator_id)}>
           {sendingId === row.cordinator_id ? 'Sending...' : 'Resend Contract'}
         </button>
       ),
     }, */
    {
      name: 'Send Contract',
      minWidth: '140px',
      cell: row => {
        const isSending = sendingId === row.cordinator_id;
        const isSigned = row.contract_status === 'signed';

        const handleClick = () => {
          if (isSigned) {
            const encodedId = btoa(row.cordinator_id); // encode id
            navigate(`/view-contract/${encodedId}`); // your route path
          } else {
            handleSendContract(row.cordinator_id);
          }
        };

        return (
          <button
            className={`${activateorgStyle.contractButton} btn btn-primary`}
            disabled={isSending}
            onClick={handleClick}
          >
            {isSending
              ? 'Sending...'
              : isSigned
                ? 'View Contract'
                : 'Resend Contract'}
          </button>
        );
      },
    },
    {
      name: 'Contract Status',
      minWidth: '120px',
      cell: row => (
        <span className={`${activateorgStyle.tablesigned} ${row.contract_status == 'signed' ? activateorgStyle.textGreen : activateorgStyle.textRed}`}>
          {row.contract_status == 'signed' ? "Signed" : "Not Signed"}
        </span>
      ),
    },
    {
      name: 'Date Contract Signed',
      minWidth: '160px',
      cell: row => row.contract_status == 'signed' ? row.signed_at : '00/00/0000',
    },
    /*{
      name: '',
      minWidth: '50px',
      cell: () => "",
    },
    {
      name: '',
      minWidth: '50px',
      cell: () => "",
    },
    {
      name: '',
      minWidth: '50px',
      cell: () => "",
    },*/
  ];

  // Custom styles for the DataTable
  const customStyles = {
    table: {
      style: {
        backgroundColor: '#FFFFFF',
        border: 'none',
        borderRadius: '0px',
        borderCollapse: 'collapse',
        borderSpacing: 0,
      },
    },
    headRow: {
      style: {
        backgroundColor: '#FFFFFF',
        borderBottom: 'none',
        minHeight: '40px',
        borderCollapse: 'collapse',
      },
    },
    headCells: {
      style: {
        font: 'normal normal 600 10px/16px Poppins',
        letterSpacing: '0px',
        color: '#707070',
        whiteSpace: 'normal',
        textAlign: 'left',
        padding: '10px 5px',
        border: '1px solid #dee2e6',
        borderCollapse: 'collapse',
        justifyContent: 'center',
        overflow: 'visible',
      },
    },
    sortIcon: {
      style: {
        position: 'absolute !important',
        right: '8px !important',
        top: '50%',
        transform: 'translateY(-50%)',
      },
    },
    rows: {
      style: {
        minHeight: '32px',
        fontSize: '10px',
        fontFamily: 'Poppins',
        fontWeight: 400,
        borderCollapse: 'collapse',
        color: '#707070',
        '&:not(:last-of-type)': {
          borderBottomStyle: 'none',
        },
      },
    },
    cells: {
      style: {
        font: 'normal normal 400 10px/24px Poppins',
        letterSpacing: '0px',
        color: '#707070',
        textAlign: 'center',
        padding: '5px',
        border: '1px solid #dee2e6',
        borderCollapse: 'collapse',
        justifyContent: 'center',
      },
    },
    pagination: {
      style: {
        borderTop: '1px solid #dee2e6',
        paddingTop: '15px',
        font: 'normal normal 400 12px/18px Poppins',
      },
      pageButtonsStyle: {
        color: '#001B64',
        fill: '#001B64',
      },
    },
  };





  return (
    <>
      <AdminHeader />
      <div className={activateorgStyle.activatedschoolsorgpage} style={{ minHeight: '700px' }}>
        <div className="container">
          <div className='row mb-4'>
            <div className='col-xl-12'>
              <BackBar />
            </div>
          </div>
          <div className="row">
            <div className="col-lg-3">
              <AdminSideBar />
            </div>
            <div className="col-lg-9">
              <div className={activateorgStyle.activatedschoolBody}>
                <div className={activateorgStyle.activatedschoolPartone}>
                  <div className="row">
                    <div className="col-lg-8">
                      <div className="row">
                        <div className="col-lg-3">
                          <label className={`${activateorgStyle.aslabel} form-label`}>School/Org Name</label>
                        </div>
                        <div className="col-lg-8">

                          <select className={`${activateorgStyle.asformSelect} form-select mb-2`} multiple value={selectedSchools} onChange={handleSchoolSelectChange}>
                            <option value="All">All</option>
                            {schools.length > 0 ? (
                              schools.map((school, index) => (
                                <option key={index} vlaue={school.school_name} selected>{school.school_name}</option>
                              ))
                            ) : (
                              <option selected>-No Data Available-</option>
                            )}
                          </select>

                        </div>





                      </div>
                    </div>
                    <div className="col-lg-4">

                      <div className='row gx-3 mb-2'>
                        <div className="col-lg-2">
                          <label className={`${activateorgStyle.aslabel} form-label`}>Year:</label>
                        </div>
                        <div className="col-lg-5">
                          <select className={`${activateorgStyle.asformSelect} form-select mb-2`} onChange={handleFromYearChange}>
                            <option value="">From</option>
                            {fromyears.length > 0 ? (
                              fromyears.map((year, index) => (
                                <option key={index} value={year}>
                                  {year}
                                </option>
                              ))
                            ) : (
                              <option selected>-No Data Available-</option>
                            )}
                          </select>
                        </div>
                        <div className="col-lg-5">
                          <select className={`${activateorgStyle.asformSelect} form-select mb-2`} onChange={handleToYearChange}>
                            <option value="">To</option>
                            {toyears.length > 0 ? (
                              toyears.map((year, index) => (
                                <option key={index} value={year}>
                                  {year}
                                </option>
                              ))
                            ) : (
                              <option selected>-No Data Available-</option>
                            )}
                          </select>
                        </div>
                      </div>


                      <div className="row">
                        <div className="col-lg-3">
                          <label className={`${activateorgStyle.aslabel} form-label`}>Search:</label>
                        </div>
                        <div className="col-lg-9">
                          <input type="text" className={`${activateorgStyle.asformControl} form-control`} value={searchTerm} onChange={handleSearch} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={activateorgStyle.activatedschoolParttwo}>
                  <DataTable
                    columns={columns}
                    data={filteredSchools}
                    pagination
                    paginationPerPage={5}
                    paginationRowsPerPageOptions={[5, 10, 15, 20]}
                    highlightOnHover
                    striped
                    responsive
                    customStyles={customStyles}
                    progressPending={isLoading}
                    noDataComponent={<div style={{ padding: '10px', textAlign: 'center', color: '#707070', fontFamily: 'Poppins', fontSize: '12px' }}>No Data Available</div>}
                    sortIcon={<span style={{ paddingLeft: '5px' }}>▼</span>}
                    sortIconRight
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AdminFooter />
    </>
  );
}
